import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getGeofences } from '../../services/geofence.service';
import { Geofence } from '../../types/Geofence';

interface geofenceState {
  stationGeofences?: Geofence[] | null;
  stationGeofencesTotal?: number;
  facilityGeofences?: Geofence[] | null;
}

const initialState: geofenceState = {
  stationGeofences: null,
  stationGeofencesTotal: 0,
  facilityGeofences: null,
};

export const fetchStationGeofences = createAsyncThunk('geofences/getStationGeofences', async (param: any) => await getGeofences(param));
export const fetchFacilityGeofences = createAsyncThunk('geofences/getFacilityGeofences', async (param: any) => await getGeofences(param));

export const geofenceSlice = createSlice({
  name: 'geofences',
  initialState,
  reducers: {
    updateStationGeofenceState: (state, action: PayloadAction<Geofence[] | null>) => {
      state.stationGeofences = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStationGeofences.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.status === 200) {
          if (action.payload.data?.results && action.payload.data?.results.length > 0) {
            state.stationGeofences = [...(state.stationGeofences ?? []), ...(action.payload.data?.results ?? [])];
            state.stationGeofencesTotal = action.payload.data.totalCount;
          }
        }
      })
      .addCase(fetchFacilityGeofences.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.status === 200) {
          if (action.payload.data?.results && action.payload.data?.results.length > 0) {
            state.facilityGeofences = [...(state.facilityGeofences ?? []), ...(action.payload.data?.results ?? [])];
          }
        }
      });
  },
});

export const { updateStationGeofenceState } = geofenceSlice.actions;
export default geofenceSlice.reducer;
